import { render, staticRenderFns } from "./restricciones-colaboraciones-agregar.vue?vue&type=template&id=16182193&"
import script from "./restricciones-colaboraciones-agregar.vue?vue&type=script&lang=js&"
export * from "./restricciones-colaboraciones-agregar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports